var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "component-header",
    class: {
      'onlyShowSelected': !_vm.onlyShowSelected
    },
    attrs: {
      "id": "pageHeader"
    }
  }, [_c('div', {
    staticClass: "bg",
    class: {
      float: _vm.nowScrollTop > 0,
      'onlyShowSelected': !_vm.onlyShowSelected
    },
    style: {
      transform: 'translateY(' + (_vm.nowScrollTop > 0 ? _vm.hdMH : 0) + 'px)'
    }
  }, [_c('div', {
    staticClass: "shop-header",
    attrs: {
      "id": "shopHeader"
    }
  }, [_c('div', {
    staticStyle: {
      "display": "flex"
    }
  }, [_c('div', {
    staticClass: "name"
  }, [_c('span', [_vm._v(_vm._s(_vm.shopName))])]), _c('div', {
    staticClass: "edit-icon"
  }, [!_vm.inPreview ? _c('ycf-svg', {
    staticClass: "icon iconfont",
    attrs: {
      "icon-name": "order_evaluate"
    },
    on: {
      "click": _vm.toPrmmoterSetting
    }
  }) : _vm._e()], 1)]), _vm.showCity ? _c('cityComponts', {
    staticClass: "address-box",
    class: {
      'showing': _vm.cityDialowShow
    },
    attrs: {
      "noPrecise": "true",
      "filterCityNumber": 4,
      "filterDistrictNumber": 4,
      "defaultData": _vm.defaultPosition
    },
    on: {
      "submitcity": _vm.submitCity,
      "dialogshow": _vm.getCityDialogShow,
      "getuserdata": _vm.getUserData
    }
  }) : _vm._e()], 1), _vm.showNav ? _c('shopNav', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: !_vm.onlyShowSelected,
      expression: "!onlyShowSelected"
    }],
    attrs: {
      "firstType": _vm.conditionId
    },
    on: {
      "update": _vm.upDateNav
    }
  }) : _vm._e()], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };